<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import "@/assets/css/theme.css";
import "@/assets/css/style.css";
export default {};
</script>
